<offline-signed-out></offline-signed-out>
<splash-screen></splash-screen>
<errors></errors>
<install-modal></install-modal>

<div class="screen-size">{{ screenSize }}</div>

<!-- Normal -->
<div class="app app--authenticated" *ngIf="(showApp$ | async) && (currentAccount$ |async)?.accessToApplications.app === true">
    <main-navigation class="app__navigation"></main-navigation>
    <header class="app__header"></header>
    <mobile-header></mobile-header>
    <div class="app__content">
        <div class="app__content__main">
            <router-outlet></router-outlet>
        </div>
        <ha-sidebar class="app__content__sidebar">
            <bookmarks-panel top></bookmarks-panel>
        </ha-sidebar>
    </div>
    <app-mobile-navigation></app-mobile-navigation>
</div>

<!-- Not authenticated -->
<div class="app" *ngIf="(isAuthenticated$ | async) === false">
    <mobile-header></mobile-header>
    <div class="app__content">
        <div class="app__content__main">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<!-- Authenticated but no user -->
<div class="app" *ngIf="(isAuthenticated$ | async) === true && ((noUserFound$ | async) === true || (currentAccount$ |async)?.accessToApplications.app === false)">
    <div class="app__content">
        <div class="app__content__main">
            <app-no-access></app-no-access>
        </div>
    </div>
</div>

<!-- Authenticated but startup seems stuck -->
<div class="app" *ngIf="(startupRecoveryVisible$ | async) === true">
    <div class="app__content">
        <div class="app__content__main">
            <div class="app__startup-recovery">
                <h1 class="app__startup-recovery__title">Still loading your account</h1>
                <p class="app__startup-recovery__description">
                    We are signed in, but the app is taking longer than expected to finish loading.
                </p>
                <p class="app__startup-recovery__description">
                    You can try loading again, or clear local browser data and reload the site.
                </p>
                <div class="app__startup-recovery__actions">
                    <button class="app__startup-recovery__retry-button" type="button" (click)="retryStartup()">
                        Try again
                    </button>
                    <button
                        class="app__startup-recovery__reset-button"
                        type="button"
                        (click)="clearLocalBrowserDataAndReload()"
                    >
                        Clear local browser data and reload
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
